import type { CutRow, MaterialPhaseGroup } from "../../engines/types";

export function groupCutRows(rows: CutRow[], phases: MaterialPhaseGroup[]) {
	const phaseByKey = new Map(
		phases.flatMap((group) =>
			group.rows.flatMap((row) =>
				row.materialKey ? [[row.materialKey, group.phase] as const] : [],
			),
		),
	);
	const groups = phases.map((group) => ({
		id: group.phase as string,
		title: group.title,
		rows: [] as CutRow[],
	}));
	const other = { id: "other", title: "", rows: [] as CutRow[] };
	for (const row of rows) {
		const exactPhase = row.materialKey
			? phaseByKey.get(row.materialKey)
			: undefined;
		// Legacy cuts lack material keys. This affects display order only, never takeoff.
		const phase =
			exactPhase ??
			(/^(Bärlinor|Golvbjälkar|Golvbrädor|Undergolv|Trossbotten|Vaggor)/.test(
				row.part,
			)
				? "foundation"
				: /^(Takbjälkar|Vindskivor|Ytterpanel|Knutbrädor|Nederkantsavslut|Takfotsavslut|Stavar|Gavelskivor|Stålband)/.test(
							row.part,
						)
					? "roofExterior"
					: /^(Syll|Hammarband|Stående|King stud|Jack stud|Cripple stud|Header|Kortling|Delningsvägg|Panorama)/.test(
								row.part,
							)
						? "framing"
						: /^(Lav|Bastupanel|Innertak|Taklist)/.test(row.part)
							? "interior"
							: undefined);
		(groups.find((group) => group.id === phase) ?? other).rows.push(row);
	}
	return [...groups, other].filter((group) => group.rows.length > 0);
}
